import { render, staticRenderFns } from "./CreatePQModule.vue?vue&type=template&id=75994b06"
import script from "./CreatePQModule.vue?vue&type=script&lang=js"
export * from "./CreatePQModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports